class AnalyticsInterface {
  constructor(ga4) {
    if (!ga4) throw new Error('Analytics provider is required')
    this.ga4 = ga4
  }

  track(eventName, eventData) {
    this.ga4.track(eventName, eventData)
  }
}

export default AnalyticsInterface
